import { Injectable } from '@angular/core';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import { SessionService } from '@monsido/core/session/session.service';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';
import { Page } from '@monsido/modules/page-details/models';

export type LinkPagesRepoGetParams = BaseRepoRequestType & {
    link_id: number,
    'types[]'?: string[],
    dialogHeader?: string,
};

@Injectable({
    providedIn: 'root',
})
export class LinkPagesRepoService extends BaseRepo {
    constructor (private apiService: ApiService, protected sessionService: SessionService) {
        super();
    }

    get (params: LinkPagesRepoGetParams): Promise<MonTableCollection<Page>> {
        params = this.setGroupId(params);
        if (params.search) {
            params.search = `%${params.search}%`;
        }
        return this.apiService.get(`domains/${this.getDomainId(params.domain_id)}/links/${params.link_id}/pages`, params);
    }
}
